import React, { useState } from "react";

import "../../../assets/scss/ActivityFeed.scss";
import { Button } from "react-bootstrap";

import { DateTime } from "luxon";

import { getDateFromIso } from "../../../_helpers/stringHelper";
import File from "../../../assets/svg/File";
import Gear from "../../../assets/svg/Gear";
import Pen from "../../../assets/svg/Pen";
import { History } from "../reducers";

type ActivityFeedProps = {
  histories: History[];
};

export const ActivityFeed = ({ histories }: ActivityFeedProps) => {
  // const [showOrderModal, setShowOrderModal] = useState(false);
  // const [showOrderId, setShowOrderId] = useState(0);
  const [isClicked, setIsClicked] = useState(false);
  let timeoutID: any;

  const historyIcon = (action: string) => {
    switch (action) {
      case "CREATE":
        return (
          <div className="activity-feed-icon">
            <File color="#641ABF" />
          </div>
        );
      case "UPDATE":
        return <div className="activity-feed-icon">{<Pen />}</div>;
      case "UPDATE_STATUS":
        return (
          <div className="activity-feed-icon">
            <Gear color="#4883F7" />
          </div>
        );
      case "UPDATE_APPOINTMENT":
        return (
          <div className="activity-feed-icon">
            <Gear color="#11BFA4" />
          </div>
        );
      case "UPDATE_OPERATOR":
        return (
          <div className="activity-feed-icon">
            <Gear color="#11BFA4" />
          </div>
        );
      case "ADD_FILE":
        return (
          <div className="activity-feed-icon">
            <File color="#11BFA4" />
          </div>
        );
      default:
        return (
          <div className="activity-feed-icon">
            <File color="#666" />
          </div>
        );
    }
  };

  const refresh = () => {
    clearTimeout(timeoutID);
    setIsClicked(true);
    timeoutID = setTimeout(() => {
      setIsClicked(false);
      location.reload();
    }, 1000);
  };

  return (
    <div className="d-flex flex-column me-4 ms-3">
      <div>
        <div className="activity-feed-header">
          <span className="activity-feed-title">Flux d'activité</span>
          <span className="activity-feed-arrow">
            <Button
              size="lg"
              variant="link"
              className={isClicked ? "refresh-arrow btn-arrow" : "btn-arrow"}
              onClick={refresh}
            >
              <i className="bi bi-arrow-repeat arrow-dashboard"></i>
            </Button>
          </span>
        </div>

        <div className="activity-feed-content">
          {histories.map((history: History, index) => (
            <div className="position-relative" key={index}>
              <div className="position-absolute h-100 line-dashboard"></div>
              <div className="w-100 d-flex gap-2">
                <div className="d-flex align-items-center pt-3 feed-icon">
                  {historyIcon(history.action)}
                </div>
                <div className="activity-feed-text mt-3 w-100 p-1">
                  {history.text}
                </div>
                <div
                  title={getDateFromIso(
                    history.createdAt,
                    DateTime.DATETIME_MED_WITH_SECONDS,
                  )}
                  className="activity-feed-date d-flex justify-content-end"
                >
                  {DateTime.fromISO(history.createdAt).startOf("day") >=
                  DateTime.now().startOf("day")
                    ? getDateFromIso(history.createdAt, DateTime.TIME_SIMPLE)
                    : DateTime.fromISO(history.createdAt).toRelativeCalendar()}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/*<ModalOrderInfo show={showOrderModal} setShow={setShowOrderModal} agenda={feed[showOrderId].data} />*/}
      {/*<Button variant="outline-primary" className="mt-4 ms-4 btn-nunito">*/}
      {/*  Afficher plus*/}
      {/*</Button>*/}
    </div>
  );
};
